import React, { useState, useEffect, useRef, memo } from "react";
import { useAppContext } from "../Services/AppContext";
import { useDispatch } from "react-redux";
import { saveCartList } from "../Screen/redux/slice/cartList";

// Convert "2025-11-29 14:45:00" → Date object
function getClosingDate(fullDateTime) {
  // Directly create JS Date from the full string
  return new Date(fullDateTime.replace(" ", "T"));
}

const Countdown = memo(({ closingTime, onFinish, isBookingTime = false ,isKerala}) => {
  const dispatch = useDispatch();
  const [timeLeft, setTimeLeft] = useState(0);
  const { setTriggerTimer } = useAppContext();
  const onFinishRef = useRef(onFinish);

  useEffect(() => {
    onFinishRef.current = onFinish;
  }, [onFinish]);

  useEffect(() => {
    if (!closingTime) {
      setTimeLeft(0);
      return;
    }

    if (isBookingTime) {
      setTriggerTimer(true);
      // Toast("Time over!");
    }

    const closingDate = getClosingDate(closingTime);
    const now = new Date();
    const initialDiff = closingDate - now;

    if (initialDiff <= 0) {
      setTimeLeft(0);
      if (onFinishRef.current) onFinishRef.current();
      dispatch(saveCartList([]));
      localStorage.removeItem("cart");
      return;
    } else {
      setTimeLeft(initialDiff);
    }

    const interval = setInterval(() => {
      const now = new Date();
      const diff = closingDate - now;

      if (diff <= 0) {
        clearInterval(interval);
        setTimeLeft(0);
        if (onFinishRef.current) onFinishRef.current();
        // localStorage.removeItem("cart");
      } else {
        setTimeLeft(diff);
      }
    }, 1000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [closingTime, isBookingTime]);

  const hours = String(Math.floor(timeLeft / (1000 * 60 * 60))).padStart(
    2,
    "0",
  );
  const minutes = String(
    Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)),
  ).padStart(2, "0");
  const seconds = String(Math.floor((timeLeft % (1000 * 60)) / 1000)).padStart(
    2,
    "0",
  );

  return (
    <div className="coundownsize f4"  style={{ color: isKerala ? "#fff" : "black" }}>{`${hours}:${minutes}:${seconds}`}</div>
  );
});

export default Countdown;
